import $ from 'jquery';

class MobileNav {
  constructor() {
    this.mainNav = $('.js-nav');
    this.navToggle = $('.js-nav-toggle');

    this.rwd = $('.rwd--768');

    this.slideToogle();
    this.submenus();
  }

  isMobile() {
    return this.rwd.css('opacity') === '1';
  }

  slideToogle() {
    if (!this.mainNav.length || !this.navToggle.length) {
      return;
    }

    this.navToggle.on('click', () => {
      if (this.mainNav.hasClass('is-open')) {
        this.mainNav.slideUp(300);
      } else {
        this.mainNav.slideDown(
          {
            start: () => {
              this.mainNav.css({
                display: 'flex',
              });
            },
          },
          300,
        );
      }

      this.mainNav.toggleClass('is-open');
    });

    $(window).on('load resize', () => {
      if (!this.isMobile() || this.mainNav.hasClass('is-open')) {
        this.mainNav.css({
          display: 'flex',
        });
      } else {
        this.mainNav.hide();
      }
    });
  }

  submenus() {
    this.mainNav.find('.js-nav-link').on('click', e => {
      if (!this.isMobile()) {
        return;
      }

      const self = $(e.currentTarget);
      const href = self.attr('href');

      if (
        href.substr(0, 1) === '#' ||
        self.parent().hasClass('menu-item-has-children')
      ) {
        e.preventDefault();
      }

      if (self.parent().hasClass('menu-item-has-children')) {
        const dropdown = self.parent().find('.js-nav-dropdown');

        if (dropdown.length) {
          this.mainNav
            .find('.js-nav-dropdown')
            .not(dropdown)
            .removeClass('is-open');
          dropdown.toggleClass('is-open');
        }
      }
    });
  }
}

export default MobileNav;



// WEBPACK FOOTER //
// ./src/scripts/modules/mobile-nav.js